// extracted by mini-css-extract-plugin
module.exports = {"footer":"_3KHsaZ","text":"_1FxGUH","hero":"_3kN_4S"};